<ca-file-explorer-breadcrumb
    *ngIf="!activeDataset"
    [rootTitle]="'FILE_EXPLORER.TABS.MY_DATASETS' | translate"
    (onClickOnHome)="openRootFolder()"
    (onClickOnBreadcrumbItem)="openFolder($event, true)"
></ca-file-explorer-breadcrumb>
<!-- My Datasets -->
<ng-container>
    <ca-list-shell
        *ngIf="!activeDataset"
        (onTriggerSearchAndSort)="onDatasetListSearch($event)"
        [totalItemsCount]="totalRowCount"
        [showCategoryButton]="false"
        [showFilterCheckBoxes]="false"
        [sortOptions]="sortOptions"
        [pageSize]="defaultPageSize"
        [updateParameterQuery]="false"
    >
        <div
            class="result-list-header mt-2 button-box w-100 d-flex justify-content-start align-items-center"
            [class.filter-and-searchbar-hidden]="!isDatasetRootFolder"
        >
            <!-- "fake" table header to prevent jumping when switching tabs -->
            <span class="ms-2 my-2" *ngIf="foldersToShow.length > 0 || filesToShow.length > 0">
                {{ 'GENERAL.COLUMN.NAME' | translate }}
            </span>
        </div>
        <div class="dataset-folder-container">
            <ca-folder-item *ngFor="let folder of foldersToShow" [name]="folder.name" (click)="openDatasetFolder(folder)"></ca-folder-item>
        </div>
    </ca-list-shell>
    <ca-dataset-explorer
        *ngIf="activeDataset"
        [dataset]="activeDataset"
        [filesTableMode]="FILE_EXPLORER_MODE.SELECTION"
        [isButtonBarShown]="false"
        [isUploadModal]="true"
        [isFilesStatusShown]="isFilesStatusShown"
        [fileActions]="actionsForFilesTable"
        [fileColumns]="columnsForFilesTable"
        [showSelectAllFilesButton]="true"
        [useRouting]="false"
        (clickOnFile)="selectFile($event)"
        (leaveDataset)="openRootFolder()"
        (onClickOnPrependedBreadcrumbElement)="openRootFolder()"
        (selectMultipleFiles)="selectMultipleFiles($event)"
        class="d-block h-100 modal-view"
    ></ca-dataset-explorer>
</ng-container>
